import React, { useContext, useState } from "react";
import "../../../ui-styles/conference/whiteBoard.css";
import { LangCtx } from "../../../lib/context";
import Loader from "../../../lib/ui/loader/Loader";

const WhiteBoard = (props) => {
    const { l } = useContext(LangCtx);
    const [loading, setLoading] = useState(true);
    // const url = `${process.env.REACT_APP_whiteboardurl}?whiteboard/id=${props.roomId}&username=${props.name}`;
    const url =`https://wb.invc.in/#room=${props.roomId},4hk1OT3cCrh3k5PgQc3amg`
    return (
        <div className="topToolsContainer">
            <div className="whiteBoardCntnr">
                <div className="whiteBoardHdr">
                    <div className="wbHdrBlock">
                        <div className="wbHdrTitleCol">
                            <span>{l.whiteboard}</span>
                        </div>
                        {props.isHost && <div className="closeBox" onClick={props.handleClose}></div>}
                    </div>
                </div>
                <div className="whiteBoardBdy">
                    {loading && <Loader />}
                    <iframe src={url} onLoad={() => setLoading(false)} title={l.instavc_whiteBoard} width="100%"/>
                </div>
            </div>
        </div>
    )
}

export default WhiteBoard;